import { IBlackjackLobby } from "@api/types/blackjack";

import getReducersLayout from "@redux/utils/getReducersLayout";
import { createSlice } from "@reduxjs/toolkit";

const initialState: IBlackjackLobby = {
  min_stake: 0,
  max_stake: 0,
  rooms: [],
};

const blackjackLobbySlice = createSlice({
  name: "blackjack-lobby",
  initialState,
  reducers: {
    ...getReducersLayout(initialState),
  },
});

export const { resetData, setData } = blackjackLobbySlice.actions;

export default blackjackLobbySlice;
